import ContactSelector, {
    ContactObjectSelector, ContactSelectorConfig,
} from 'app/shared-components/ContactSelector'
import Checkbox from 'app/shared-components/Checkbox'
import InputSingleline, {
    InputSingleLineConfig,
} from 'app/shared-components/InputSingleline'
import DateTimeZonedSelect, {
    DateTimeZonedSelectConfig,
} from 'app/shared-components/DateTimeZonedSelect'
import CompanySelector, {
    CompanyObjectSelectorConfig,
    CompanyObjectSelector,
} from 'app/shared-components/CompanySelector'
import CompanyDataSelector from 'app/shared-components/CompanySelector/CompanyDataSelector'
import IntegerInput, {
    IntegerInputConfig,
} from 'app/shared-components/IntegerInput'
import LongText, {
    LongTextConfig,
} from 'app/shared-components/InputMultiline'
import {
    LocationSelectorConfig,
    LocationSelectorComponents,
} from 'app/shared-components/LocationSelector'
import DateTimeZonedFromLocation, {
    DateTimeZonedFromLocationConfig,
} from 'app/Apps/OrderManagement/Orders/Components/OrderStepsForm/DateTimeZonedFromLocation'
import MultipleContactSelector, {
    MultipleContactObjectSelector,
    MultipleContactByLocationObjectSelector,
    MultipleContactSelectorConfig,
} from 'app/shared-components/MultipleContactSelector'
import LinkTo, {
    LinkToConfig,
} from 'app/shared-components/LinkTo'
import LinkToClick, {
    LinkToClickConfig,
} from 'app/shared-components/LinkToClick'
import SkyNetLink, {
    SkyNetLinkConfig,
} from 'app/shared-components/SkyNetLink'
import {
    AttachmentsObjectSelector, AttachmentsObjectSelectorConfig,
} from 'app/shared-components/Attachment'
import AllowedContainerTypes
    from 'app/Apps/OrderManagement/Orders/CustomerTransport/CustomerTransportsOverview/AllowedContainerTypes'
import RequiredContainerByProductTypeList, {
    RequiredContainersByProductTypeListConfig,
} from 'app/shared-components/AdvancedList/components/RequiredContainerByProductTypeList'
import RequiredContainersByContainerTypeList, {
    RequiredContainersByContainerTypeListConfig,
} from 'app/shared-components/AdvancedList/components/RequiredContainersByContainerTypeList'
import GeneralFreight from 'app/shared-components/GeneralFreight'
import OrderStatus from 'app/Apps/OrderManagement/Orders/Components/OrderStatus'
import OrderStatusHistory, {
    OrderStatusHistoryConfig,
} from 'app/Apps/OrderManagement/Orders/Components/OrderStatusHistory'
import SelectedAssets from 'app/Apps/OrderManagement/Orders/Components/SelectedAssets'
import BookedContainers
    from 'app/Apps/OrderManagement/Orders/CustomerTransport/CustomerTransportsOverview/BookedContainers'
import SelectContainerTypeByCode from 'app/Apps/ContainerManagement/Containers/components/SelectContainerTypeByCode'
import AvailableLanes, {
    AvailableLanesConfig,
} from 'app/Apps/OrderManagement/Orders/CustomerTransport/CreateDirectLease/Steps/OrderDetails/AvailableLanes'
import AirlineLeaseAvailableLane, {
    AirlineLeaseAvailableLaneConfig,
} from 'app/Apps/OrderManagement/Orders/CustomerTransport/CreateAirlineLease/Steps/SelectLaneStep/AvailableLanes'
import SendTime, {
    SendTimeConfig,
} from 'app/Apps/OrderManagement/Orders/Components/OrderNotifications/OrderNotificationForm/SendTime'
import SentFirstTimeOn, {
    SentFirstTimeOnConfig,
} from 'app/Apps/OrderManagement/Orders/Components/OrderNotifications/OrderNotificationForm/SentFirstTimeOn'
import DefaultAttachments
    from 'app/Apps/OrderManagement/Orders/Components/OrderNotifications/OrderNotificationForm/DefaultAttachments'
import RecipientSelector
    from 'app/Apps/OrderManagement/Orders/Components/OrderNotifications/OrderNotificationForm/RecipientSelector'
import MultipleBusinessDevelopersSelect from 'app/shared-components/MultipleBusinessDevelopersSelect'
import DateTimeSelect, {
    DateTimeSelectorConfig,
} from 'app/shared-components/DateTimeSelect'
import TruckCapacity, {
    TruckCapacityConfig,
} from 'app/shared-components/TruckingCapacity'
import CustomerExecutionSelector
    from 'app/Apps/Pricing/ContractBasis/components/PrintFiltersForm/CustomerExecutionSelector'
import {
    CustomerExecutionSelectorConfig,
} from 'app/Apps/Pricing/ContractBasis/components/PrintFiltersForm/CustomerExecutionSelector/CustomerExecutionSelector.types'
import TemperatureAge from 'app/common/DomainObject/ComponentMapper/TemperatureAge'
import StatusAge from 'app/common/DomainObject/ComponentMapper/StatusAge'
import ConnectedLoggers from 'app/Apps/LoggersAndGateways/Gateways/ConnectedLoggers'
import GatewayContacts from 'app/Apps/LoggersAndGateways/Gateways/GatewayContacts'
import LoggerTypeSelector from 'app/shared-components/LoggerTypeSelector'
import SharePositioningSelect, {
    SharePositioningSelectConfig,
} from 'app/shared-components/SharePositioningSelect'
import LocationChangeSelector, {
    LocationChangeSelectorConfig,
} from 'app/shared-components/LocationChangeSelector'
import LoggerSelector from 'app/shared-components/LoggerSelector'
import StatusSelector from 'app/shared-components/StatusSelector'
import ContainerSelector from 'app/shared-components/ContainerSelector'
import FileDownloadLink from 'app/shared-components/FileDownloadLink'
import Fees from 'app/shared-components/Fees'
import {
    FeesConfig,
} from 'app/shared-components/Fees/Fee.types'
import StatusTransitionSelector, {
    StatusTransitionSelectorConfig,
} from 'app/shared-components/StatusTransitionSelector'
import DateSelect from 'app/shared-components/DateSelect'
import AirportLaneGroupSelector, {
    AirportLaneGroupSelectorConfig,
} from 'app/Apps/Pricing/ContractBasis/components/PrintFiltersForm/AirportLaneGroupSelector'
import PreviousOrdersITCreationForm, {
    PreviousOrdersITCreationFormConfig,
} from 'app/Apps/OrderManagement/Orders/InternalTransport/CreateInternalTransportForm/CreateManuallyForm/PreviousOrdersITCreationForm'
import {
    BillingCompanyObjectSelector,
    BillingCompanyExpandedViewSelector,
} from 'app/shared-components/BillingCompanySelector'
import InputRule, {
    InputRuleConfig,
} from 'app/shared-components/InputRule'
import Switch from 'app/shared-components/Switch'
import BookedFreight from 'app/Apps/OrderManagement/Orders/InternalTransport/InternalTransportsOverview/BookedFreight'
import BillingInformationContainers
    from 'app/Apps/OrderManagement/Orders/CustomerTransport/BillingInformation/Containers'
import PreviousOrders, {
    PreviousOrdersConfig,
} from 'app/Apps/OrderManagement/Orders/InternalTransport/InternalTransportsOverview/PreviousOrders'
import ContactNameComment from 'app/Apps/ContactManagement/Contacts/ContactNameComment'
import ChipSelect from 'app/shared-components/ChipSelect'
import GoogleAddress, {
    GoogleAddressConfig,
} from 'app/shared-components/GoogleAddress'
import CountrySelector, {
    CountryDataSelector,
} from 'app/shared-components/CountrySelector'
import CitySuggestions, {
    CitySuggestionsConfig,
} from 'app/Apps/ContactManagement/utils/CitySuggestions'
import TaxCodesSelector, {
    TaxCodesSelectorConfig,
} from 'app/shared-components/TaxCodesSelector'
import ContactsLinked from 'app/Apps/ContactManagement/ContactsLinked/Contacts'
import StateSelector, {
    StateSelectorConfig,
} from 'app/shared-components/StateSelector'
import ContactsContainer from 'app/Apps/ContactManagement/ContactsLinked/ContactsContainer'
import SelectedContainersUpdateLocation
    from 'app/Apps/OrderManagement/Orders/Components/OrderSteps/SavedOrderStepsForm/UpdateLocationDialog/SelectedContainers'
import {
    TypeaheadObjectContainer,
    TypeaheadObjectContainerConfig,
} from 'app/shared-components/Typeahead'
import TableFees, {
    TableFeesConfig,
} from 'app/Apps/Pricing/TableFees'
import AccountSelector, {
    AccountSelectorConfig,
} from 'app/shared-components/AccountSelector'
import SkyNetSpreadSheet, {
    SkyNetSpreadSheetConfig,
} from 'app/shared-components/SkyNetSpreadSheet'
import AreaSelector, {
    AreaSelectorConfig,
} from 'app/shared-components/AreaSelector'
import CurrencyHeadingSelector, {
    CurrencyHeadingSelectorConfig,
} from 'app/shared-components/CurrencyHeadingSelector'
import BooleanReader from 'app/shared-components/BooleanReader'
import OpportunitiesSelector from 'app/shared-components/OpportunitiesSelector'
import ContractBasisSelector from 'app/shared-components/ContractBasisSelector'
import RegionalGroupSelector, {
    RegionalGroupSelectorConfig,
} from 'app/shared-components/RegionalGroupSelector'
import RouteSelection from 'app/Apps/TransportPlanner/Simulation/RouteSelection'
import AnalyseTemperature from 'app/Apps/TransportPlanner/Simulation/AnalyseTemperature'
import RouteSteps from 'app/Apps/TransportPlanner/Simulation/RouteSteps'
import ContainerTypeSelection from 'app/Apps/TransportPlanner/Simulation/ContainerTypeSelection'
import LaneSelector from 'app/shared-components/LaneSelector'
import UserSelector, {
    UserObjectSelector,
} from 'app/shared-components/UserSelector'
import MultipleUserSelector from 'app/shared-components/MultipleUserSelector'
import MultipleUserSelectorTypeConfig from 'app/shared-components/MultipleUserSelector/MultipleUserSelector.types'
import MultipleAccountSelector from 'app/shared-components/MultipleAccountSelector'
import CustomerExecutionQuotationSelector from 'app/shared-components/CustomerExecutionSelector'
import RestrictedPermissionInputSingleline, {
    RestrictedPermissionInputSinglelineConfig,
} from 'app/shared-components/RestrictedPermissionInputSingleline'
import ZipCodeInput, {
    ZipCodeInputConfig,
} from 'app/shared-components/ZipCodeInput'
import SingleForecastSpreadsheet from 'app/Apps/Forecast/ShortTermForecasts/SingleForecastSpreadsheet'
import SingleForecastSpreadsheetConfig
    from 'app/Apps/Forecast/ShortTermForecasts/SingleForecastSpreadsheet/SingleForecastSpreadsheet.types'
import AttitudeToSkyCell from 'app/Apps/RelationshipsManagement/Engagement/EngagementForm/AttitudeToSkyCell'
import ProductMetrics, {
    ProductMetricsConfig,
} from 'app/Apps/ContainerManagement/ServiceCenters/ServiceCenterForm/ProductMetrics'
import ContainerProductionRate
, {
    ContainerProductionRateConfig,
} from 'app/Apps/ContainerManagement/ServiceCenters/ServiceCenterForm/ContainerProductionRate'
import DeploymentSelector from 'app/shared-components/DeploymentSelector'

import MultipleCompaniesSelector from 'app/shared-components/MultipleCompaniesSelector'
import MultipleCompaniesSelectorConfig
    from 'app/shared-components/MultipleCompaniesSelector/MultipleCompaniesSelector.types'
import MultipleCountriesSelector from 'app/shared-components/MultipleCountriesSelector'
import MultipleCountriesSelectorConfig
    from 'app/shared-components/MultipleCountriesSelector/MultipleCountriesSelector.types'
import MultipleSelect from 'app/shared-components/MultipleSelect'
import MultipleSelectConfig from 'app/shared-components/MultipleSelect/MultipleSelectContainer.types'
import InputIntegerNumbers from 'app/shared-components/InputIntegerNumbers'
import DedicatedContainers from 'app/Apps/OrderManagement/LongTermLease/Containers/DedicatedContainers'
import DateRangeSelectorMui, {
    DateRangeSelectorMuiConfig,
} from 'app/shared-components/DateRangeSelectorMui'
import LaneGroupByContractSelector, {
    LaneGroupByContractSelectorConfig,
} from 'app/shared-components/LaneGroupByContractSelector'
import LongTermLeaseSelector, {
    LongTermLeaseSelectorConfig,
} from 'app/shared-components/LongTermLeaseSelector'

import EnumSelector from 'app/shared-components/EnumSelector'
import EnumSelectorConfig from 'app/shared-components/EnumSelector/EnumSelector.types'
import TimePicker from 'app/shared-components/TimePicker'
import TimePickerConfig from 'app/shared-components/TimePicker/TimePicker.types'
import DamageTypeSelector from 'app/shared-components/DamageTypeSelector'
import MultipleUserChipSelect from 'app/shared-components/MultipleUserChipSelect'
import MultipleUserChipSelectTypeConfig
    from 'app/shared-components/MultipleUserChipSelect/MultipleUserChipSelect.types'
import CheckboxConfig from 'app/shared-components/Checkbox/Checkbox.types'
import OrderLink from 'app/shared-components/OrderLink'
import ContractBasisSelectorConfig from 'app/shared-components/ContractBasisSelector/ContractBasisSelector.types'
import ListView from 'app/shared-components/ListView'
import OpportunitiesSelectorTypeConfig
    from 'app/shared-components/OpportunitiesSelector/OpportunititesSelector.types'
import FreightForwarderSelector, {
    FreightForwarderSelectorConfig,
} from 'app/shared-components/FreightForwarderSelector'
import OperationalDays from 'app/Apps/ContainerManagement/ServiceCenters/components/OperationalDays'
import MultipleDeploymentSelector from 'app/shared-components/MultipleDeploymentSelector'
import Storages, {
    StoragesConfig,
} from 'app/Apps/ContainerManagement/ServiceCenters/ServiceCenterForm/Storages'

import {
    EnumComponents, EnumComponentConfig,
} from './EnumComponents.config.types'

const componentsDefaultProps = {
    AccountSelector,
    AllowedContainerTypes,
    AnalyseTemperature,
    AttitudeToSkyCell,
    AvailableLanes,
    BillingCompanyExpandedViewSelector,
    BillingCompanyObjectSelector,
    BillingInformationContainers,
    BookedContainers,
    BookedFreight,
    BooleanReader,
    ChipSelect,
    CompanyDataSelector,
    CompanyObjectSelector,
    CompanySelector,
    ConnectedLoggers,
    ContactNameComment,
    ContactsContainer,
    ContactsLinked,
    ContainerSelector,
    ContainerTypeSelection,
    CountryDataSelector,
    CountrySelector,
    CustomerExecutionQuotationSelector,
    DamageTypeSelector,
    DateSelect,
    DedicatedContainers,
    DefaultAttachments,
    DeploymentSelector,
    FileDownloadLink,
    GatewayContacts,
    GeneralFreight,
    InputIntegerNumbers,
    LaneSelector,
    ListView,
    LoggerSelector,
    LoggerTypeSelector,
    MultipleAccountSelector,
    MultipleBusinessDevelopersSelect,
    MultipleContactObjectSelector,
    MultipleContactSelector,
    MultipleDeploymentSelector,
    OrderLink,
    OrderStatus,
    RecipientSelector,
    RouteSelection,
    RouteSteps,
    SelectContainerTypeByCode,
    SelectedAssets,
    SelectedContainersUpdateLocation,
    SingleForecastSpreadsheet,
    StatusAge,
    StatusSelector,
    Storages,
    OperationalDays,
    Switch,
    TemperatureAge,
    UserObjectSelector,
    UserSelector,
}

type componentsDefaultPropsConfig = {
    componentName?: keyof typeof componentsDefaultProps,
}

export const ComponentsFormCollection = {
    ...componentsDefaultProps,
    ...LocationSelectorComponents,
    ...EnumComponents,
    AccountSelector,
    AirlineLeaseAvailableLane,
    AirportLaneGroupSelector,
    AreaSelector,
    AttachmentsObjectSelector,
    Checkbox,
    CitySuggestions,
    ContactObjectSelector,
    ContactSelector,
    ContainerProductionRate,
    ContractBasisSelector,
    CurrencyHeadingSelector,
    CustomerExecutionSelector,
    DateRangeSelectorMui,
    DateTimeSelect,
    DateTimeZonedFromLocation,
    DateTimeZonedSelect,
    EnumSelector,
    Fees,
    FreightForwarderSelector,
    GoogleAddress,
    InputRule,
    InputSingleline,
    IntegerInput,
    LaneGroupByContractSelector,
    LinkTo,
    LinkToClick,
    LocationChangeSelector,
    LongTermLeaseSelector,
    LongText,
    MultipleCompaniesSelector,
    MultipleContactByLocationObjectSelector,
    MultipleCountriesSelector,
    MultipleSelect,
    MultipleUserChipSelect,
    MultipleUserSelector,
    OrderStatusHistory,
    OpportunitiesSelector,
    PreviousOrders,
    PreviousOrdersITCreationForm,
    ProductMetrics,
    RegionalGroupSelector,
    RequiredContainerByProductTypeList,
    RequiredContainersByContainerTypeList,
    RestrictedPermissionInputSingleline,
    SendTime,
    SentFirstTimeOn,
    SharePositioningSelect,
    SkyNetLink,
    SkyNetSpreadSheet,
    StateSelector,
    StatusTransitionSelector,
    TableFees,
    TaxCodesSelector,
    TimePicker,
    TruckCapacity,
    TypeaheadObjectContainer,
    ZipCodeInput,
}

export type ComponentsFormCollectionNames = keyof typeof ComponentsFormCollection

export type ComponentsFormCollectionProps<T = {}>
    = componentsDefaultPropsConfig
    | AccountSelectorConfig
    | AirlineLeaseAvailableLaneConfig
    | AirportLaneGroupSelectorConfig
    | AreaSelectorConfig
    | AttachmentsObjectSelectorConfig
    | AvailableLanesConfig
    | CheckboxConfig
    | CitySuggestionsConfig
    | CompanyObjectSelectorConfig
    | ContactSelectorConfig
    | ContainerProductionRateConfig
    | ContractBasisSelectorConfig
    | CurrencyHeadingSelectorConfig
    | CustomerExecutionSelectorConfig
    | DateRangeSelectorMuiConfig<T>
    | DateTimeSelectorConfig
    | DateTimeZonedFromLocationConfig
    | DateTimeZonedSelectConfig
    | EnumComponentConfig
    | EnumSelectorConfig
    | FeesConfig
    | FreightForwarderSelectorConfig
    | GoogleAddressConfig
    | InputRuleConfig
    | InputSingleLineConfig
    | IntegerInputConfig
    | LaneGroupByContractSelectorConfig
    | LinkToClickConfig
    | LinkToConfig
    | LocationChangeSelectorConfig
    | LocationSelectorConfig
    | LongTermLeaseSelectorConfig
    | LongTextConfig
    | MultipleCompaniesSelectorConfig
    | MultipleContactSelectorConfig
    | MultipleCountriesSelectorConfig
    | MultipleSelectConfig
    | MultipleUserChipSelectTypeConfig
    | MultipleUserSelectorTypeConfig
    | OrderStatusHistoryConfig
    | OpportunitiesSelectorTypeConfig
    | PreviousOrdersConfig
    | PreviousOrdersITCreationFormConfig
    | ProductMetricsConfig
    | StoragesConfig
    | RegionalGroupSelectorConfig
    | RequiredContainersByContainerTypeListConfig
    | RequiredContainersByProductTypeListConfig
    | RestrictedPermissionInputSinglelineConfig
    | SendTimeConfig
    | SentFirstTimeOnConfig
    | SharePositioningSelectConfig
    | SingleForecastSpreadsheetConfig
    | SkyNetLinkConfig
    | SkyNetSpreadSheetConfig<any>
    | StateSelectorConfig
    | StatusTransitionSelectorConfig
    | TableFeesConfig
    | TaxCodesSelectorConfig
    | TimePickerConfig
    | TruckCapacityConfig
    | TypeaheadObjectContainerConfig
    | ZipCodeInputConfig
